export default "__VITE_ASSET__BUvfI2_3__"